import generateCohortValue from 'lib/generateCohortValue';
import isMobileWidth from 'lib/isMobileWidth';

import configureAnalytics from './configureAnalytics';
import configureGateways from './configureGateways';
import configureStore from './configureStore';

import appEnums from 'enums/app';
import appEvents from 'events/app';
import configEvents from 'events/configuration';
import uiEnums from 'enums/ui';
import uiEvents from 'events/ui';

import checkAuth from 'actions/user/checkAuth';
import fetchConfiguration from 'actions/configuration/fetchConfiguration';
import fetchConfigSuccess from 'actions/configuration/fetchConfigSuccess';
import fetchEstimatedWaitTime from 'actions/app/fetchEstimatedWaitTime';
import handleMessageReceived from 'actions/messages/handleMessageReceived';
import handleMessageSent from 'actions/messages/handleMessageSent';
import handleTypingEvent from 'actions/messages/handleTypingEvent';
import loadConfiguration from './loadConfiguration';
import { getCohortId } from '../selectors/configuration';
import minimizeWidget from 'actions/ui/minimizeWidget';
import ApiObserver from 'lib/apiObserver';

const REFRESH_CONFIG_INTERVAL = 60000; // 60 seconds in ms
const ESTIMATED_WAIT_TIME_INTERVAL = 30000; // 30 seconds in ms

export default (async function(cdn, config, deviceConfig) {
  const serverConfiguration = await loadConfiguration(cdn, config.appId);
  const { appId } = config;
  const { provider, providerId, orgId, loginDomain, clusterUrl: orgDomain } = serverConfiguration;

  const observers = new ApiObserver();
  configureAnalytics();
  const gateways = configureGateways({ appId, cdn, provider, deviceConfig });
  const store = configureStore({ config, deviceConfig, gateways, observers });

  gateways.chatGateway.registerConnectionCallbacks({
    handleConnected: () => store.dispatch(appEvents.chatClientConnected()),
    handleDisconnected: () => store.dispatch(appEvents.chatClientDisconnected()),
  });

  gateways.messageGateway.registerCallbacks({
    handleTypingEvent: typingEvent => store.dispatch(handleTypingEvent(typingEvent)),
    handleMessageSent: message => store.dispatch(handleMessageSent(message)),
    handleMessageReceived: message => store.dispatch(handleMessageReceived(message)),
  });

  const state = store.getState();
  if (!getCohortId(state.configuration)) {
    store.dispatch(configEvents.setCohortId(generateCohortValue()));
  }

  store.dispatch(uiEvents.initWidget({ orgDomain, loginDomain, appId, providerId, orgId, cdn }));
  store.dispatch(fetchConfigSuccess(serverConfiguration));

  if (isMobileWidth() && deviceConfig.platform === appEnums.platforms.WEB) {
    store.dispatch(minimizeWidget);
  }

  if (config.autoShowWidget) {
    store.dispatch(uiEvents.autoShowWidget());
  }

  if (deviceConfig.platform !== appEnums.platforms.WEB) {
    store.dispatch(uiEvents.navigateForward(uiEnums.LOCATIONS.CHAT));
  }

  await gateways.chatGateway.configureProvider(providerId);
  await store.dispatch(checkAuth);

  // start polling for config so we can see if config ever gets updates
  window.setInterval(() => store.dispatch(fetchConfiguration), REFRESH_CONFIG_INTERVAL);

  await store.dispatch(fetchEstimatedWaitTime);
  window.setInterval(() => store.dispatch(fetchEstimatedWaitTime), ESTIMATED_WAIT_TIME_INTERVAL);

  return { store, observers };
});
